export function isValidSortOption(option: string) {
  const validSortOptions = [
    '-weighted_rating',
    'weighted_rating',
    'price',
    '-price',
    'rating',
    '-rating',
    'distance',
    'magic',
    'best',
    '-best',
  ]
  return validSortOptions.includes(option)
}
